export default class Fonts {
	public static get Arial(): string {
		return "arial";
	}
	public static get Chewy(): string {
		return "chewy-regular";
	}

	public static get Titanone(): string {
		return "titanone-regular";
	}

	public static get MontserratExtraBold(): string {
		return "montserrat-extrabold";
	}

	public static get MontserratBold(): string {
		return "montserrat-bold";
	}

	public static get DisneyJr(): string {
		return "disney-junior";
	}

	public static get DisneyJrBold(): string {
		return "disney-junior-bold";
	}
}
